import { render, staticRenderFns } from "./Pause.vue?vue&type=template&id=6b4622cd&scoped=true&"
var script = {}
import style0 from "./Pause.vue?vue&type=style&index=0&id=6b4622cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4622cd",
  null
  
)

component.options.__file = "Pause.vue"
export default component.exports